$(function () {
  // Main page category inner collapse

  const categoryInnerHtml = (color, image, inner) => {
    return (
      '<div id="js-main-category-inner" class="df-main__categories__grid__item__inner" style="--bg-color: ' +
      color +
      "; --bg-img: " +
      image +
      ';"><div class="df-main__categories__grid__item__inner__content"><div class="row">' +
      inner +
      "</div></div></div>"
    );
  };

  const collapseCategoryInner = ($activeCategory) => {
    $(".js-main-category").each(function () {
      if ($(this).get(0) !== $activeCategory.get(0)) {
        $(this).removeClass("active");
        $(this).addClass("muted");
      } else {
        $(this).removeClass("muted");
        $(this).addClass("active");
      }
    });

    const inner = $activeCategory.data("inner");
    const color = $activeCategory.css("--bg-active-color");
    const image = $activeCategory.css("--bg-img");
    let index;
    let nextEl;

    if (window.matchMedia("(min-width: 992px)").matches) {
      index = Number($activeCategory.data("lg-index"));
      if (index != 0) {
        nextEl =
          $activeCategory.nextAll("[data-lg-index='0']").first()
            .length > 0
            ? $activeCategory.nextAll("[data-lg-index='0']").first()
            : $activeCategory.nextAll("[data-lg-index='4']").first()
                .length > 0
            ? $activeCategory.nextAll("[data-lg-index='4']").first()
            : $activeCategory.nextAll("[data-lg-index='3']").first()
                .length > 0
            ? $activeCategory.nextAll("[data-lg-index='3']").first()
            : $activeCategory.nextAll("[data-lg-index='2']").first()
                .length > 0
            ? $activeCategory.nextAll("[data-lg-index='2']").first()
            : $activeCategory.nextAll("[data-lg-index='1']").first()
                .length > 0
            ? $activeCategory.nextAll("[data-lg-index='1']").first()
            : $activeCategory;
      }
    } else if (window.matchMedia("(min-width: 768px)").matches) {
      index = Number($activeCategory.data("md-index"));
      if (index != 0) {
        nextEl =
          $activeCategory.nextAll("[data-md-index='0']").first()
            .length > 0
            ? $activeCategory.nextAll("[data-md-index='0']").first()
            : $activeCategory.nextAll("[data-md-index='2']").first()
                .length > 0
            ? $activeCategory.nextAll("[data-md-index='2']").first()
            : $activeCategory.nextAll("[data-md-index='1']").first()
                .length > 0
            ? $activeCategory.nextAll("[data-md-index='1']").first()
            : $activeCategory;
      }
    } else {
      index = Number($activeCategory.data("index"));
      if (index != 0) {
        nextEl =
          $activeCategory.nextAll("[data-index='0']").first().length > 0
            ? $activeCategory.nextAll("[data-index='0']").first()
            : $activeCategory.nextAll("[data-index='1']").first()
                .length > 0
            ? $activeCategory.nextAll("[data-index='1']").first()
            : $activeCategory;
      }
    }
    $(categoryInnerHtml(color, image, inner)).insertAfter(
      index == 0 ? $activeCategory : nextEl
    );
    const height = $("#js-main-category-inner")
      .find(".df-main__categories__grid__item__inner__content")
      .get(0).scrollHeight;
    console.log(height);
    $(".df-main__categories__grid__item__inner").animate(
      { minHeight: "185px", height: height, maxHeight: height },
      300
    );
  };

  $(".js-main-category").on("click", function () {
    const $activeCategory = $(this);
    if ($("#js-main-category-inner").get(0)) {
      $("#js-main-category-inner").animate(
        {
          minHeight: "0px",
          maxHeight: "0px",
          height: "0px",
          opacity: "0",
        },
        300,
        function () {
          $("#js-main-category-inner").css("display", "none");
          $("#js-main-category-inner").remove();

          if (!$activeCategory.hasClass("active")) {
            collapseCategoryInner($activeCategory);
          } else {
            $(".js-main-category").removeClass("muted");
            $activeCategory.removeClass("active");
          }
        }
      );
    } else {
      collapseCategoryInner($activeCategory);
    }
  });
});
